import { z } from 'zod';

export const UserResiliationResultSchema = z.object({
  userId: z.number(),
  groupeId: z.number(),
  alreadyProcessed: z.boolean(),
  subscriptionCancelled: z.boolean(),
  stripeSubscriptionId: z.string().nullable(),
  usersSoftDeleted: z.number(),
  inventairesSoftDeleted: z.number(),
  profilsSoftDeleted: z.number(),
});

export const UserResiliationResponseSchema = z.object({
  message: z.string(),
  data: UserResiliationResultSchema,
});

export type UserResiliationResult = z.infer<typeof UserResiliationResultSchema>;
export type UserResiliationResponse = z.infer<typeof UserResiliationResponseSchema>;
